import React from 'react'

export const Portal = () => {
  return (
    <div>Portal</div>
  )
}
